import FinanceRegistry from "../features/finance/components/FinanceRegistry";

export default function Finance() {
  return (
    <FinanceRegistry />
  );
}
